export enum ANDROID_SETTINGS_CONSTANTS {
  MAIN = 'SETTINGS',
  SECURITY = 'SECURITY_SETTINGS',
  ACCESSIBILITY = 'ACCESSIBILITY_SETTINGS',
}

export const getAndroidSettingsConstant = (
  constant: ANDROID_SETTINGS_CONSTANTS
) => {
  return `android.settings.${constant}`;
};
